import {deleteToken} from '@/shared/lib/firebase';
import {clearLocalStorage} from '@/shared/lib/localStorage/clearLocalStorage';
import {sendCampaignIfExists} from '@/features/campaign/api';
import {
  clearStorage,
  initializeWorker,
  storeData,
} from '@/workers/sharedWorkerInstance';

import {LOCAL_STORAGE} from './localStorage';
import {APP_ROUTES} from './routes';

export const handleLogout = async (
  id?: string,
  user_id?: string,
  until?: number
) => {
  if (localStorage.getItem('fireToken')) {
    await deleteToken();
  }

  clearLocalStorage();
  clearStorage();

  // TODO workaround: there is no way understood that function clearStorage finished
  setTimeout(() => {
    if (!id) {
      window.location.href = APP_ROUTES.Login;
      return;
    }

    window.location.href = `${APP_ROUTES.ErrorBanned}?banId=${id}&userId=${user_id}&until=${until}`;
  }, 200);
};

export const handleLoginSuccess = (loginResponse: any) => {
  clearLocalStorage();
  const token = loginResponse.token.access;
  const {home} = loginResponse;

  if (token && home) {
    localStorage.setItem(LOCAL_STORAGE.AuthToken, token);
    initializeWorker();
    storeData('authToken', token);
    storeData('userData', home);
    storeData('matches', {
      list_new: home.matches_new,
      list_open: home.matches_open,
      unreads: home.unreads,
      users: home.users,
    });

    sendCampaignIfExists();

    return true;
  }

  return false;
};
